/**
 * 字典
 */
export default class Dictionary {

    constructor({items = [], valueKey = 'value', textKey = 'text'} = {}) {
        this.items = items;
        this.valueKey = valueKey;
        this.textKey = textKey;
    }

    getValue(text) {
        let item = this.getItem(text, this.textKey);
        return item == null ? text : item[this.valueKey];
    }

    getText(value, defaultText) {
        defaultText = defaultText == null ? value : defaultText;
        let item = this.getItem(value, this.valueKey);
        let text;
        if (item == null) {
            text = defaultText;
        } else {
            text = item[this.textKey];
            if (text == null) {
                text = defaultText;
            }
        }
        return text;
    }

    getItemByValue(value) {
        return this.getItem(value, this.valueKey);
    }

    getItemByText(text) {
        return this.getItem(text, this.textKey);
    }

    getItem(value, valueKey) {
        valueKey = valueKey || this.valueKey;
        let item;
        for (let i = 0, l = this.items.length; i < l; i++) {
            if (String(this.items[i][valueKey]) === String(value)) {
                item = this.items[i];
                break;
            }
        }
        return item;
    }

    getValues() {
        let values = [];
        for (let i = 0, l = this.items.length; i < l; i++) {
            values.push(this.items[i][this.valueKey]);
        }
        return values;
    }

    getTexts() {
        let values = [];
        for (let i = 0, l = this.items.length; i < l; i++) {
            values.push(this.items[i][this.textKey]);
        }
        return values;
    }

}